<form class="f-col blank-form cm-managetraveler-page" [formGroup]="reportingForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managetraveler.reportingmanager']}}<div class="dot">.</div> <span
                class="optional">{{content?.['b2b.managetraveler.optional']}}</span></h2>

        <a tabindex="0" role="button" class="link" (click)="Editemployee()"
            *ngIf="hasEmployeeData && Loader.isEditableClicked && isAdminUser"><mat-icon
                fontSet="material-symbols-outlined" class="edit-icon">edit</mat-icon>
            {{content?.['b2b.managetraveler.edit']}}</a>
    </div>

    <div class="section-content">
        <div class="inner-contentsection">

            <div class="f-row">
                <div class="f-col">
                    <mat-form-field appearance="fill" data-dd-privacy="mask">
                        <mat-label>Manager Name</mat-label>
                        <input matInput type="text" [formControl]="managerSearchControl" [matAutocomplete]="managerAuto"
                            autocomplete="off" (input)="onManagerSearchInput($event)" (focus)="onManagerFocus()" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="managerSearchControl.value && !Loader.isEditableClicked && isAdminUser"
                            (click)="clearManager($event)" aria-label="Clear manager">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #managerAuto="matAutocomplete" (optionSelected)="onManagerSelected($event)">
                            <mat-option *ngIf="filteredManagerList.length === 0" [disabled]="true">
                                {{managerNoItemsText}}
                            </mat-option>
                            <mat-option *ngFor="let user of filteredManagerList" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.managetraveler.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
        </div>


        <div class="inner-contentsection">

            <div class="f-row">
                <div class="f-col">
                    <mat-form-field appearance="fill" data-dd-privacy="mask">
                        <mat-label>{{content?.['b2b.managetraveler.travelerarrangers'] || 'Travelerarranger'}}</mat-label>
                        <input matInput type="text" [formControl]="travelArrangerSearchControl"
                            [matAutocomplete]="travelArrangerAuto" autocomplete="off"
                            (input)="onTravelArrangerSearchInput($event)" (focus)="onTravelArrangerFocus()" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="travelArrangerSearchControl.value && !Loader.isEditableClicked && isAdminUser"
                            (click)="clearTravelArranger($event)" aria-label="Clear travel arranger">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #travelArrangerAuto="matAutocomplete"
                            (optionSelected)="onTravelArrangerSelected($event)">
                            <mat-option *ngIf="filteredTravelArrangerList.length === 0" [disabled]="true">
                                {{travelArrangerNoItemsText}}
                            </mat-option>
                            <mat-option *ngFor="let user of filteredTravelArrangerList" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.managetraveler.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-action" *ngIf="!Loader.isEditableClicked && isAdminUser">
            <button mat-button class="button--secondary-small"
                (click)="OnCancel()">{{content?.['b2b.managetraveler.cancel'] || 'Cancel'}}</button>
            <button mat-button class="button--primary-small no-focus" [class.disabled]="!isSaveEnabled() || Loader.isSpinner"
                (click)="onSave()">{{content?.['b2b.managetraveler.save'] || 'Save'}}
                <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>

            </button>
        </div>
    </div>
</form>